export default "__VITE_ASSET__Dvxbbq84__"